export { Checkbox as CheckboxComponent } from "@centricsoftware/design-system";
export type { CheckboxProps as CheckboxComponentProps } from "@centricsoftware/design-system";

